<template>
  <messenger-chat-survey-log-message-layout :rate="rate">
    <div class="text-center">{{ logItem.text }}</div>
  </messenger-chat-survey-log-message-layout>
</template>

<script lang="ts" setup>
import type { MessengerCommentLeftLogMessageListItem } from '@widgets/messenger/types/chat/message'
import MessengerChatSurveyLogMessageLayout from '@widgets/messenger/components/messages/MessengerChatSurveyLogMessageLayout.vue'
import type { MessengerChatRate } from '@widgets/messenger/types/chat/chat'

defineProps<{
  logItem: MessengerCommentLeftLogMessageListItem
  rate?: MessengerChatRate
}>()
</script>
